export const environment = {
  url: 'https://dev-api-machine.credebt.com/', //dev url
  clientId: '91acf499-ee2e-4548-9de7-1a21d99b4946',
  authority: 'https://login.microsoftonline.com/7653f2c8-b98b-4cb3-8f2d-4e0b7c7a9e4b',
  TimeOut: 300,
  Idle: 1500,
};
